import React from 'react';
import { useParams } from 'react-router-dom';
import PageHeading from '~/components/PageHeading';
import CustomQuestionEditor from '~/components/customquestions/CustomQuestionEditor';
import useBusinessNavigate from '~/lib/useBusinessNavigate';

/**
 * The custom question editor as its own page. The form designer opens the same
 *  editor in a modal from the Add Element panel.
 */
const CustomQuestionEditPage = () => {
    const { customQuestionId } = useParams();
    const navigate = useBusinessNavigate();

    return (
        <CustomQuestionEditor
            customQuestionId={customQuestionId}
            renderHeading={heading => (
                <PageHeading
                    crumbs={[
                        { name: 'Extensions', href: '/custom-questions' },
                    ]}
                    heading={heading}
                    limitWidth={false}
                />
            )}
            onCreated={id => navigate(`/custom-questions/${id}`)}
            onSaved={(customQuestion, wasNew) => {
                if (wasNew && customQuestion?.id) {
                    navigate(`/custom-questions/${customQuestion.id}`);
                }
            }}
            onDeleted={() => navigate('/custom-questions')}
        />
    );
};

export default CustomQuestionEditPage;
